module.exports = "/assets/data/7a76e2ae17f083f050422fd36fc534e0-SO21.data.json";